const replaceSpacesWithHyphens = (word) => {
  if (!word) {
    return null
  }
  return word?.replace(/ /g, '-')?.toLowerCase()
}

const replaceSpacesWithUnderscore = (word) => {
  if (!word) {
    return null
  }
  return word?.replace(/ /g, '_')?.toLowerCase()
}

const getAncillariesNode = (ancillaries) => {
  const tagMap = {
    SEATS: 'seat',
    CARRY_ON: 'carryonbag',
    CHECKED_BAG: 'checkedbag',
  }
  return ancillaries
    ?.filter((a) => ['SEATS', 'CARRY_ON', 'CHECKED_BAG'].includes(a?.tag))
    ?.map((a) => {
      if (a?.offerType === 'C') {
        return `${tagMap[a?.tag]}_f`
      } else if (a?.offerType === 'F') {
        return `${tagMap[a?.tag]}_p`
      } else {
        return `${tagMap[a?.tag]}_n`
      }
    })
    ?.join('_')
}

const getCabinClass = (visibleFareBrands) => {
  return visibleFareBrands?.reduce((acc, fb, index) => {
    const sanitizedCabinClass = fb?.name?.replace(' ', '-')?.toLowerCase()
    if (index === 0) {
      acc = sanitizedCabinClass
    } else {
      acc = acc + '_' + sanitizedCabinClass
    }
    return acc
  }, '')
}

const getItemBrand = (segments = []) => {
  if (segments.length > 0 && segments.every((s) => s.marketingAirline)) {
    const airlines = segments.map((s) => s.marketingAirline?.toLowerCase())
    const allSame = airlines.every((airline) => airline === airlines[0])
    return allSame ? segments[0].marketingAirline.toLowerCase() : airlines.join('_')
  }
  return null
}

export {
  getCabinClass,
  getAncillariesNode,
  replaceSpacesWithHyphens,
  replaceSpacesWithUnderscore,
  getItemBrand,
}
